import styled from 'styled-components';
import media from 'src/styles/Media.styled';

export const AnnouncementContainer = styled.div`
    height: calc(100vh - 4rem);
    display: flex;
    flex-direction: column;
    ${media.mobileDevice`
        margin-top: -3.8rem;
        height: 100%;
    `}
`;

export const AnnouncementHeaderContainer = styled.div`
    display: block;
    ${media.mobileDevice`
        position: fixed;
        width: 100%;
    `}
`;

export const AnnouncementContent = styled.div`
    display: flex;
    flex-direction: column;
    background: #f5f5f5 0% 0% no-repeat padding-box;
    ${media.mobileDevice`
    display:flex;
    flex-direction: column;
    width: unset;
    padding: 20px 16px 15px 16px;
    border-top-left-radius: 20px;
    border-top-right-radius: 20px;
    display: block;
    margin: -1px 0 0 0;
    background: #F5F5F5;
    ${media.mobileDevice`
        padding: 35px 16px 15px 16px;
        margin: 62px 0 0 0;
        height: 100%;
    `}
`}
`;
export const HeaderContainer = styled.h2`
    display: flex;
    font-family: AvenirNextWorld Demi;
    padding: 16px 0 10px 0;
    margin: 0;
    color: #140f4b;

    ${media.mobileDevice`
    color: #FFFFFF;
    background: ${(props) => props.theme.calendarBackgroundColor} !important;
    padding: 0 16px 20px 16px;
`}
`;
export const BoxContainer = styled.div`
    display: none;
    ${media.mobileDevice`
    display:flex;
    flex-direction:column;
    padding: 10px 27px 16px 16px;
    background: #FFFFFF 0% 0% no-repeat padding-box;
    box-shadow: 0px 0px 6px #00000029;
    border-radius: 6px;
    opacity: 1;
    margin-bottom: ${({ marginBottom }) =>
        marginBottom ? marginBottom : '10px'};
`}
`;

export const StyledDate = styled.div`
    text-align: left;
    font: 14px Avenir Next World;
    font-family: 'AvenirNextWorld Demi';
    line-height: 22px;
    letter-spacing: 0px;
    color: #3c3c3c;
    opacity: 1;
    flex-basis: 15%;

    ${media.mobileDevice`
    flex-basis:0%;
    width: 48px;
    height: 20px;
    text-align: left;
    font:9px Avenir Next World;
    font-family:'AvenirNextWorld Demi';
    line-height:20px;
    letter-spacing: -0.08px;
    color: #767676;
    opacity: 1;
`}
`;
export const Information = styled.div`
    flex-basis: 85%;
    text-align: left;
    font: 14px Avenir Next World;
    font-family: AvenirNextWorld Regular;
    letter-spacing: 0px;
    opacity: 1;

    ${media.mobileDevice`
    flex-basis:0%;
    width: 314px;
    height: 45px;
    text-align: left;
    font-size:14px;
    font-family:AvenirNextWorld Regular;
    letter-spacing: 0px;
    color: #3C3C3C;
    opacity: 1;
    margin-top:5px;
    & > p {
        padding-top: 0;
        padding-bottom: 0;
        margin-top: 0;
        margin-bottom: 0;
    }
`}
`;

export const MessageData = styled.div`
    font-family: AvenirNextWorld Regular;
    font-size: 14px;
    color: #3c3c3c;
    opacity: 1;
    text-align: left;
`;
